import { getGenericProjectKeys } from '../projectKeys'

import { useProjectKeysStore } from './project-keys.store'

const fetchGroupsRequestByProjectId = new Map<string, Promise<void>>()

export function resetProjectKeysFetchInFlight(): void {
  fetchGroupsRequestByProjectId.clear()
}

export async function fetchGroups(projectId: string): Promise<void> {
  const { setGroups, setLoading, setError } = useProjectKeysStore.getState()

  if (!projectId) {
    setGroups([])
    setLoading(false)
    setError(null)
    return
  }

  const inFlightRequest = fetchGroupsRequestByProjectId.get(projectId)
  if (inFlightRequest) {
    return inFlightRequest
  }

  const request = (async () => {
    setLoading(true)
    setError(null)

    try {
      const groups = await getGenericProjectKeys(projectId)
      setGroups(groups)
      setLoading(false)
      setError(null)
    } catch {
      setLoading(false)
      setError('Failed to load project keys.')
    } finally {
      fetchGroupsRequestByProjectId.delete(projectId)
    }
  })()

  fetchGroupsRequestByProjectId.set(projectId, request)
  return request
}
